<template>
  <!--<List :mapState="'restaurantEnlistment'" :allDispatch="'restaurantEnlistmentAll'"></List>-->
  <b-card>
    <div>
       <div>
        <b-form-group>
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-chevron-right"></i></b-input-group-text>
          </b-input-group-prepend>
          <b-form-file @change="processFile($event)" v-model="measurementValueDisplay" accept=".jpg, .png" name="filee" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
          <button @click="sendFile">Enviar</button>
        </b-input-group>
        </b-form-group>
      </div>
    </div>
  </b-card>
</template>
<script>
import List from '@/components/modules/base/list.vue'
import axios from "axios";

export default {
  name: 'Lists',
  data(){
    return {
      Datafield: {},
      Datadata: '',
      enteredValue: '',
      file: {},
      formData: new FormData()
    }
  },
  components: {
    List
  },
  computed: {
    measurementValueDisplay: {
      get: function () {
        return this.enteredValue
      },
      set: function (newValue) {
        this.enteredValue = newValue
      }
    }
  },
  methods: {
    processFile (event) {
      this.file = event.target.files[0]
      this.formData.append('myFile', this.file, this.file.name)
    },
    sendFile () {
      const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        };
      axios.post('http://localhost:8000/api/admin/users', this.formData, config)

      /*this.$store.dispatch('adminUsersCreateIMG',this.formData).then(response => {
        alert('sended')
      })*/
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/restaurant/enlistment/list.vue